import React, { useState, useEffect } from "react";
import { getAllBrands } from "../../services/campaign";
import Link from "next/link";
import Image from "next/image";
import { uniqueFilter } from "../../utils/filters";
export const baseURL = `${process.env.BASE_URL}/`;
import WhiteLogo from "../../public/images/ico-logo/white.png";

const topBrands = {
  success: true,
  brandsList: [
    {
      _id: "64177a6bc1877fb6b1264343",
      userId: "6345efd6528436ae8b37f1a1",
      logoUrl: "/images/ico-logo/white.png",
      coverUrl:
        "https://api.impactoverse.com/public/displayImages/cover_1679260267274_715564_c5457987-76ff-4f03-8a9b-3e40298ed972.jpg",
      isFeatured: false,
      name: "Impactoverse",
      about:
        "Impactoverse is an impact ecosystem and Impact Art marketplace. We power brand and cause-driven collaborations to scale business outcomes as well as social and environmental impact.",
      country: "United States",
      city: "Wyoming",
      category: "Science & Technology",
      websiteUrl: "www.impactoverse.com",
      socials: ["https://www.linkedin.com/company/impactoverse/"],
      registrationNum: "882024491",
      countryOfRegistration: "United States",
      activeCampaigns: [
        {
          _id: "64181f64c1877fb6b1264456",
          overview: {
            campaignName: "PetDrops",
            campaignType: "OPEN",
            description:
              "PetDrops is a super-campaign sponsored by Impactoverse benefiting animal welfare organizations.\r\n\r\nAs part of our mission to make web3 more accessible, we created PetDrops as turnkey Impact Art campaign option for people, businesses, and impact initiatives, especially those that are new to the Impact Art space. We chose animal welfare for its universal appeal, as a bridge that can bring together in common purpose across industries, sectors and borders. \r\n\r\nBrands, influencers, or NPOS can easily set up and run approved cause marketing  sub-campaigns under the PetDrops super-campaign umbrella. \r\n\r\nCreators can collaborate with brands or participate directly by contributing, purchasing, or gifting Impact ArtS in the PetDrops marketplace. \r\n\r\nPet lovers and other animal welfare advocates can easily and safely purchase and gift Impact Arts in the PetDrops marketplace, no cryptocurrency needed. \r\n\r\nAll transactions benefit animal welfare organizations. Our intention is that, over time, the PetDrops Super Campaign will scale the impact of thousands of sub-campaigns, donating millions of dollars to animal welfare organizations across the globe. \r\n",
            startDate: "2023-03-20T22:13:10.000Z",
            endDate: "2025-12-30T22:00:10.000Z",
            bannerImageUrl: [
              "public/uploads/identityVerifications/banner_1679302334084_228488_ae3fdb3f-a8df-48c1-a332-abf12bdaf025.jpg",
            ],
            isSuperCampaign: true,
            isSubCampaign: false,
            superCampaignId: "",
            superCampaignName: "",
          },
        },
      ],
    },
    {
      _id: "63c3e85f4df378abfe55ccd9",
      userId: "63c3e0964df378abfe55cc94",
      logoUrl:
        "https://api.impactoverse.com/public/displayImages/logo_1674830812017_837870_logo.png",
      coverUrl:
        "https://api.impactoverse.com/public/displayImages/cover_1674830812024_187983_cover.jpg",
      isFeatured: true,
      name: "AUNUA Global",
      about:
        "AUNUA, launched in 2017 is an organization that is FOR YOUTH. FOR IMPACT. With the aim of giving youth a voice, supporting them to develop their individual strengths, and overcome challenges while creating a better world for them to live in. ",
      country: "Ireland",
      city: "Tallaght",
      category: "Education & Training",
      websiteUrl: "www.aunuaglobal.org",
      socials: ["https://www.linkedin.com/company/aunua-academy  "],
      registrationNum: 623198,
      countryOfRegistration: "Ireland",
      activeCampaigns: [
        {
          _id: "6447d36e1fbc6ac0dfdbddb7",
          overview: {
            campaignName: "Masha's Legacy",
            campaignType: "OPEN",
            description:
              "We are grateful to have this campaign as part of the Positive Vibes Movement. Masha Kaylee, 13, a joyful girl, full of life, who loves running, swimming, cycling and other outdoor activities, 4th in her class at school, all set to start secondary (high) school this year. Devastatingly, she was diagnosed with stage 4 bone cancer putting a tragic end to many of her dreams in January of this year, 2023. Only a few months later she is incapacitated and in a wheelchair, with no independence and in a great deal of pain. \n\nWith a change in circumstances, her hobbies now are colouring, and small scale drawings. She uses Art to keep a positive attitude and to keep herself distracted and wants to inspire kids out there in a similar situation, but also wants to do something to help herself as well as others like her.\n\nMuch of the treatment she needs has to be paid for privately, and Masha and other cancer patients and their families often finding themselves making tough choices between getting treatment and medication, or food. This campaign is an opportunity for Masha to use her creative escape and the art of others too to help cover the costs of treatment, food, counselling and transport for her and other children she knows, even for just a short time. \n\nWe hope that you will consider supporting this great cause. In addition to the images you buy being your evidence of the impact you had in the life of children in need, you will also be able to use this as a ticket to the Positive Vibes Festival later this year (live and online). Please see aunuaglobal.com for more. \n\nYou can also support us by contributing some images too, (and you can earn too if your image sells if you choose to get a percentage of the sales), and please share with your network and get them to buy what you contributed. Even if we get a small percentage of the sale of the image you contribute to our campaign, it will help! \n\nIf you're wondering about what we will do with funds, this campaign is to fund meals, counselling and oncologist visits for Masha and 6 other youth for 6 months. \n\nPer youth the cost for 6 months of oncologist visits, meals, vitamin supplements, medication, and counselling would be $1500 ($250 per month)\n\nThis campaign is to support 3 youth to start and we hope to be able to show everyone the work that is being done and gain more support to help more youth and their families.\n\nThe total amount we would be looking to raise is $750 per month for 6 months, so $4500 in total for 6 months.\n\nAgain, please consider buying an image to support and if you can't afford that, please contribute an image toward the campaign and share it and share this campaign. Thank you!",
            startDate: "2023-04-26T11:41:41.000Z",
            endDate: "2024-01-31T11:41:41.000Z",
            bannerImageUrl: [
              "public/uploads/identityVerifications/banner_1682428781936_187581_96176901-b39e-4b26-9ebb-a708af4360a0.png",
            ],
            isSuperCampaign: false,
            isSubCampaign: true,
            superCampaignId: "63c42a6b4df378abfe55cd84",
            superCampaignName: "AUNUA POSITIVE VIBES",
            country: "Uganda",
          },
        },
        {
          _id: "6416fb5cc1877fb6b1264098",
          overview: {
            campaignName: "Esther's Orphanage ",
            campaignType: "OPEN",
            description:
              "This is a campaign that is part of the Positive Vibes movement. We hope that you will support us and spread more positive vibes!!\n\nThe Orphanage is run by Esther who first realised what it felt like to be helpless after losing her dad. She was determined to help other children so that they would never need to experience the same struggles that she had.\n\nShe started the orphanage by supporting 3 children and this has grown with her now looking after the needs of 20, from ages 3 upward.   The orphanage, predominantly through Esther, provides support and security of a home for these vulnerable children who are entirely dependent on the orphanage for their education, clothing, food, shelter and well-being. \n\nDespite Esther's noble intentions for these children and to save them from suffering, life is still a struggle as the orphanage is largely dependent on donations which are in short support. Esther is running this campaign to reduce the dependency on donations, to provide a more sustainable solution to the hunger the children face and a long term solution for their well-being. \n\nFood security is important and this campaign is to fundraise for some land, animals and provisions for a vegetable garden so that the orphanage can be more self-sufficient and less reliant on donations. Please support our campaign by buying an image or event contributing an image and sharing with your network. \n\nThis campaign is a part of the Positive Vibes Super Campaign so all Impact Arts will also give the owners entry to The Positive Vibes Festival in August. More info can be found at aunuaglobal.com. \n\n",
            startDate: "2023-03-20T11:28:58.000Z",
            endDate: "2024-02-29T10:28:58.000Z",
            bannerImageUrl: [
              "public/uploads/identityVerifications/banner_1679308253392_667901_b8890f59-3a62-4675-8926-9a8d4f5d47f1.jpg",
            ],
            isSuperCampaign: false,
            isSubCampaign: true,
            superCampaignId: "63c42a6b4df378abfe55cd84",
            superCampaignName: "AUNUA POSITIVE VIBES",
            country: "Zambia",
          },
        },
      ],
    },
    {
      _id: "64bec1528ca9dd5d4d8e1310",
      userId: "64b424618ca9dd5d4d8df492",
      logoUrl:
        "https://api.impactoverse.com/public/displayImages/logo_1690222930718_724548_acfc6957-c796-4e7c-8292-0cbfbefdf07c.png",
      coverUrl:
        "https://api.impactoverse.com/public/displayImages/cover_1690222930720_262547_4a7d2d49-b547-4a5a-bb29-fd46edb38fb7.png",
      isFeatured: false,
      name: "Onpoint Technologies",
      about:
        "Onpoint Technologies is a tech-driven organization that is setup to explore business opportunities around digital technologies. Our brand as a technology-driven organization focuses on exploring ways to create values of digital/technology humanity in solving day-to-day problems. As an organization in this space, we prioritize innovation, research, and development to stay ahead of the rapidly evolving digital landscape.\r\n\r\nOnpoint Technologies' core mission may revolve around leveraging digital technologies to solve business problems, enhance efficiency, and create new revenue streams. Our expertise include a range of services or products centered around areas such as software development, artificial intelligence, cloud computing, data analytics, internet of things (IoT), cybersecurity, and more.\r\n\r\nOnpoint Technologies has a strong emphasis on fostering a culture of continuous learning and adaptability thereby enabling us to keep up with the ever-changing tech landscape. Collaborating with industry leaders, startups, and other technology-driven businesses is part of our approach to staying at the forefront of tech. ",
      country: "Nigeria",
      city: "Lagos",
      category: "Information & Communication Technology",
      websiteUrl: "www.pointtechblog.com",
      socials: ["https://twitter.com/MapEducates "],
      registrationNum: "3688536",
      countryOfRegistration: "Nigeria",
      activeCampaigns: [],
    },
  ],
};
const Topbrands = () => {
  const [loadingBrands, setLoadingBrands] = useState(true);
  const [campaign, setCampaign] = useState([]);
  const [filter, setFilter] = useState({
    category: [],
    name: [],
  });
  const [filteredCampaigns, setFilteredCampaigns] = useState([]);

  const [filterValue, setFilterValue] = useState({
    name: "",
    category: "",
    country: "",
  });
  useEffect(() => {
    const fetchApi = () => {
      getAllBrands()
        .then((result) => {
          setCampaign(topBrands.brandsList);
          setFilter((prevFilter) => ({
            ...prevFilter,
            category: uniqueFilter(
              topBrands.brandsList.map((item) => ({
                value: item.category.toLowerCase(),
                label: item.category.toLowerCase(),
              })),
            ),
            name: uniqueFilter(
              topBrands.brandsList.map((item) => ({
                value: item.name.toLowerCase(),
                label: item.name.toLowerCase(),
              })),
            ),
          }));
        })
        .catch((error) => console.log("error", error));
    };
    fetchApi();
    // Simulate data loading delay
    const delay = setTimeout(() => {
      setLoadingBrands(false);
    }, 1000);

    return () => clearTimeout(delay);
  }, []);

  useEffect(() => {
    const { country, category, name } = filterValue;

    let filteredCampaigns = campaign;

    if (country) {
      filteredCampaigns = filteredCampaigns.filter(
        (item) => item.country.toLowerCase() === country.toLowerCase(),
      );
    }

    if (name) {
      filteredCampaigns = filteredCampaigns.filter(
        (item) => item.name.toLowerCase() === name.toLowerCase(),
      );
    }

    if (category) {
      filteredCampaigns = filteredCampaigns.filter(
        (item) => item.category.toLowerCase() === category.toLowerCase(),
      );
    }
    console.log(filteredCampaigns);
    setFilteredCampaigns(filteredCampaigns);
  }, [campaign, filterValue]);
  return (
    <>
      {loadingBrands ? (
        <div className="dark:bg-jacarta-800 bg-light-base rounded-2.5xl p-12 lg:w-1/3">
          <h2 className="text-jacarta-700 font-display mb-8 text-center text-3xl font-semibold dark:text-white">
            Top Brands
          </h2>

          <div className="flex flex-col space-y-5">
            <p></p>
          </div>
          <Link
            href="/brands"
            className="text-accent mt-8 block text-center text-sm font-bold tracking-tight"
          >
            View All
          </Link>
        </div>
      ) : (
        <>
          <div className="dark:bg-jacarta-800 bg-light-base rounded-2.5xl p-12 lg:w-1/3">
            <h2 className="mb-8 block font-display text-xl font-medium group-hover:text-accent dark:text-white transition-colors text-center">
              Top Brands
            </h2>

            <div className="flex flex-col space-y-5">
              {filteredCampaigns.slice(0, 2).map((item, index) => {
                const { _id, logoUrl, name, icon, amount, category } = item;
                return (
                  <div
                    key={index}
                    className="border-jacarta-100 dark:bg-jacarta-700 rounded-2xl flex border bg-white py-4 px-7 transition-shadow hover:shadow-lg dark:border-transparent"
                  >
                    <figure className="mr-4 shrink-0">
                      <Link href={`/brands/${_id}`} className="relative block">
                        <Image
                          width={48}
                          height={48}
                          src={logoUrl}
                          alt={name}
                          className="rounded-2lg h-12 w-12"
                        />
                        <div className="dark:border-jacarta-600 bg-jacarta-700 absolute -left-3 top-1/2 flex h-6 w-6 -translate-y-2/4 items-center justify-center rounded-full border-2 border-white text-xs text-white">
                          {index + 1}
                        </div>
                        {icon && (
                          <div
                            className="dark:border-jacarta-600 bg-green absolute -left-3 top-[60%] flex h-6 w-6 items-center justify-center rounded-full border-2 border-white"
                            data-tippy-content="Verified Collection"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              width="24"
                              height="24"
                              className="h-[.875rem] w-[.875rem] fill-white"
                            >
                              <path fill="none" d="M0 0h24v24H0z"></path>
                              <path d="M10 15.172l9.192-9.193 1.415 1.414L10 18l-6.364-6.364 1.414-1.414z"></path>
                            </svg>
                          </div>
                        )}
                      </Link>
                    </figure>
                    <div>
                      <Link href={`/brands/${_id}`} className="block">
                        <span className="font-display text-jacarta-700 hover:text-accent font-semibold dark:text-white">
                          {name}
                        </span>
                      </Link>
                      <span className="dark:text-jacarta-300 text-sm">
                        {category}
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
            <Link
              href="/brands"
              className="text-accent mt-8 block text-center text-sm font-bold tracking-tight"
            >
              View All
            </Link>
          </div>
        </>
      )}
    </>
  );
};

export default Topbrands;
